module.exports = __webpack_public_path__ + "static/media/SarahSwitek_07_EnergyLevel_3.3a67d522.mp3";